/* */
/**
 * @module actions/Upgrade
 */

import * as PaymentsConstants from './constants';
import * as D from './deps';

export function listenerAndSubscriptionReady(authType) {
  return {
    type: PaymentsConstants.Actions.LISTENER_AND_SUBSCRIPTION_READY,
    data: {
      authType,
    },
  };
}

export function resetPaypalStatus() {
  return {
    type: PaymentsConstants.Actions.RESET_PAYPAL_STATUS,
  };
}

export function resetInvalidCreditCardStatus() {
  return {
    type: PaymentsConstants.Actions.RESET_INVALID_CREDIT_CARD_STATUS,
  };
}

export function resetCreditCardForm() {
  return {
    type: PaymentsConstants.Actions.CREDIT_CARD_FORM_RESET,
  };
}

export function hasFinishedPurchase() {
  return {
    type: PaymentsConstants.Actions.FINISH_ACQUIRE_PRODUCT,
  };
}

export function acquireOfferSuccess({ specialOfferToken, sku }) {
  return {
    type: PaymentsConstants.Actions.ACQUIRE_OFFER_SUCCESS,
    data: {
      specialOfferToken,
      sku,
    },
  };
}

export function switchingPlans() {
  return {
    type: PaymentsConstants.Actions.TOGGLE_SWITCHING_PLANS,
    isSwitchingPlans: true,
  };
}

export function stopSwitchingPlans() {
  return {
    type: PaymentsConstants.Actions.TOGGLE_SWITCHING_PLANS,
    isSwitchingPlans: false,
  };
}

export function updatingBillingInfo() {
  return {
    type: PaymentsConstants.Actions.UPDATING_BILLING_INFO,
  };
}

export function stopUpdatingBillingInfo() {
  return {
    type: PaymentsConstants.Actions.STOP_UPDATING_BILLING_INFO,
  };
}

/**
 * action notifying of the intent to get subscription info (new version)
 *
 * @returns {object} - returns pertinent data - subscriptionInfoV1 will be deprecated
 */
export function getSubscriptionInfoV2() {
  return {
    type: PaymentsConstants.Actions.GET_SUBSCRIPTION_INFO_V2,
  };
}

export function resetUpdatedBillingInfo() {
  return {
    type: PaymentsConstants.Actions.RESET_UPDATED_BILLING_INFO,
  };
}

export function cancelSubscription(password) {
  return {
    type: PaymentsConstants.Actions.CANCEL_SUBSCRIPTION,
    data: {
      password,
    },
  };
}

export function deleteCreditCard(password) {
  return {
    type: PaymentsConstants.Actions.DELETE_CREDIT_CARD,
    data: {
      password,
    },
  };
}

export function resubscribe() {
  return {
    type: PaymentsConstants.Actions.RESUBSCRIBE,
  };
}

export function updateCreditCardInfo() {
  return {
    type: PaymentsConstants.Actions.UPDATE_CREDIT_CARD_INFO,
  };
}

export function acquireOffer({
  tier,
  discountType,
  paymentProvider,
  durationType,
  specialOfferCode,
  getSpecialOfferType,
  paypalPurchaseInfo,
  vendorSku,
  backingProductIdentifier,
}) {
  return {
    type: PaymentsConstants.Actions.ACQUIRE_OFFER,
    data: {
      tier,
      discountType,
      paymentProvider,
      durationType,
      specialOfferCode,
      getSpecialOfferType,
      paypalPurchaseInfo,
      vendorSku,
      backingProductIdentifier,
    },
  };
}

export function prepareToAcquireOffer({
  tier,
  discountType,
  paymentProvider,
  durationType,
  specialOfferCode,
}) {
  return {
    type: PaymentsConstants.Actions.PREPARE_TO_ACQUIRE_OFFER,
    data: {
      tier,
      discountType,
      paymentProvider,
      durationType,
      specialOfferCode,
    },
  };
}

export function upgradeOffered({ sourceId, sourceType }) {
  return {
    type: PaymentsConstants.Actions.UPGRADE_OFFERED,
    data: {
      sourceId,
      sourceType,
    },
  };
}

export function cancelCurrentProduct() {
  return {
    type: PaymentsConstants.Actions.CANCEL_CURRENT_PRODUCT,
  };
}

export function exitFromFamilyPlan() {
  return {
    type: PaymentsConstants.Actions.EXIT_FROM_FAMILY_PLAN,
  };
}

export function createFamilyPlanInvite(emailAddress) {
  return {
    type: PaymentsConstants.Actions.FAMILY_PLAN_CREATE_INVITE,
    data: {
      emailAddress,
    },
  };
}

export function resendFamilyPlanInvite(emailAddress) {
  return {
    type: PaymentsConstants.Actions.FAMILY_PLAN_RESEND_INVITE,
    data: {
      emailAddress,
    },
  };
}

export function revokeFamilyPlanInvite(inviteToken, emailAddress) {
  return {
    type: PaymentsConstants.Actions.FAMILY_PLAN_REVOKE_INVITE,
    data: {
      inviteToken,
      emailAddress,
    },
  };
}

export function removeChildFromFamilyPlan(childListenerID, emailAddress) {
  return {
    type: PaymentsConstants.Actions.FAMILY_PLAN_REMOVE_CHILD,
    data: {
      childListenerID,
      emailAddress,
    },
  };
}

export function startManagingFamilyPlanAccounts(isManaging, isInviting) {
  return {
    type: PaymentsConstants.Actions.START_MANAGING_FAMILY_PLAN_ACCOUNTS,
    isManaging,
    isInviting,
  };
}

export function stopManagingFamilyPlanAccounts() {
  return {
    type: PaymentsConstants.Actions.STOP_MANAGING_FAMILY_PLAN_ACCOUNTS,
  };
}

export function logUpgradePageEvent(data) {
  return {
    type: PaymentsConstants.Actions.LOG_UPGRADE_PAGE_EVENT,
    data,
  };
}

export function onUpgradeCompleted(data) {
  return {
    type: PaymentsConstants.Actions.UPGRADE_CONFIRMATION,
    data,
  };
}

export function enterPartnerUpgradeFlow() {
  return {
    type: PaymentsConstants.Actions.ENTER_PARTNER_UPGRADE_FLOW,
  };
}

export function requestPartnerUpgrade({ tier, discountType }) {
  return {
    type: PaymentsConstants.Actions.REQUEST_PARTNER_UPGRADE,
    data: {
      tier,
      discountType,
    },
  };
}

export function anonymousStartTrialClicked({
  tier,
  discountType,
  shouldSetAnon,
  redirectAfterLogin,
}) {
  return {
    type: PaymentsConstants.Actions.ANONYMOUS_START_TRIAL_CLICKED,
    tier,
    discountType,
    shouldSetAnon,
    redirectAfterLogin,
  };
}

export function selectOffer({ tier, discountType }) {
  return {
    type: PaymentsConstants.Actions.SELECT_OFFER,
    data: {
      tier,
      discountType,
    },
  };
}

export function selectPaymentProvider(paymentProvider) {
  return {
    type: PaymentsConstants.Actions.SELECT_PAYMENT_PROVIDER,
    data: {
      paymentProvider,
    },
  };
}

export function clearSelectedOffer() {
  return {
    type: PaymentsConstants.Actions.CLEAR_SELECTED_OFFER,
  };
}

export function setIsAnonymousUpgrade() {
  return {
    type: PaymentsConstants.Actions.IS_ANONYMOUS_UPGRADE,
  };
}

export function loadPaymentsData() {
  return {
    type: PaymentsConstants.Actions.LOAD_PAYMENTS_DATA,
  };
}

export function processUpgradeAuthentication({ tierSlug, subTierSlug } = {}) {
  return {
    type: PaymentsConstants.Actions.PROCESS_UPGRADE_AUTHENTICATION,
    data: {
      tierSlug,
      subTierSlug,
    },
  };
}

export function processUpgrade({ tierSlug, subTierSlug } = {}) {
  return {
    type: PaymentsConstants.Actions.PROCESS_UPGRADE,
    data: {
      tierSlug,
      subTierSlug,
    },
  };
}

export function enterSubscriptionManagement() {
  return {
    type: PaymentsConstants.Actions.ENTER_SUBSCRIPTION_MANAGEMENT,
  };
}

export function enterFamilyPlanManagement({ currentPath }) {
  return {
    type: PaymentsConstants.Actions.ENTER_FAMILY_PLAN_MANAGEMENT,
    data: {
      currentPath,
    },
  };
}

export function setMobileMessage({ message }) {
  return {
    type: PaymentsConstants.Actions.DISPLAY_MOBILE_MESSAGE,
    data: {
      message,
    },
  };
}

export function clearMobileMessage() {
  return {
    type: PaymentsConstants.Actions.CLEAR_MOBILE_MESSAGE,
  };
}

export function openSwitchPlanModal({ selectedTier, selectedDiscountType, selectedDurationType }) {
  return {
    type: PaymentsConstants.Actions.OPEN_SWITCH_PLAN_MODAL,
    data: {
      selectedTier,
      selectedDiscountType,
      selectedDurationType,
    },
  };
}

export function openCancelSubscriptionModal() {
  return {
    type: PaymentsConstants.Actions.OPEN_CANCEL_SUBSCRIPTION_MODAL,
  };
}

export function switchPlan({
  vendorSku,
  backingProductIdentifier,
  paymentProvider,
  tier,
  discountType,
  durationType,
}) {
  return {
    type: PaymentsConstants.Actions.SWITCH_PLAN,
    data: {
      vendorSku,
      backingProductIdentifier,
      paymentProvider,
      tier,
      discountType,
      durationType,
    },
  };
}

export function enterPaypalComplete() {
  return {
    type: PaymentsConstants.Actions.PAYPAL_COMPLETE,
  };
}

export function setPaypalComplete() {
  return {
    type: PaymentsConstants.Actions.SET_PAYPAL_COMPLETE,
  };
}

export function waitForSubscriptionInfo() {
  return {
    type: PaymentsConstants.Actions.WAIT_FOR_SUBSCRIPTION_INFO,
  };
}

export function partnerUpgradeConfirmListener() {
  return {
    type: PaymentsConstants.Actions.PARTNER_UPGRADE_CONFIRM_LISTENER,
  };
}

export function initiatePartnerUpgrade({ entitlementId, tier, partnerName }) {
  return {
    type: PaymentsConstants.Actions.INITIATE_PARTNER_UPGRADE,
    data: {
      entitlementId,
      tier,
      partnerName,
    },
  };
}

export function exitPartnerUpgrade() {
  return {
    type: PaymentsConstants.Actions.EXIT_PARTNER_UPGRADE,
  };
}

export function upgradeCtaClicked({ tier, discountType, isTrial }) {
  return {
    type: PaymentsConstants.Actions.UPGRADE_CTA_CLICK,
    data: {
      tier,
      discountType,
      isTrial,
    },
  };
}

export function upgradeDiscountPlanLinkClicked({ tier, discountType, isTrial }) {
  return {
    type: PaymentsConstants.Actions.UPGRADE_DISCOUNT_PLAN_LINK_CLICKED,
    data: {
      tier,
      discountType,
      isTrial,
    },
  };
}

export function redirectToDiscountVerification({ tierSlug, verificationType } = {}) {
  return D.getInDomain('payments.actions._verification_.redirectToDiscountVerification')({
    tierSlug,
    verificationType,
  });
}

export function getDiscountVerificationInfo({ discountType, requestId }) {
  return D.getInDomain('payments.actions._verification_.getDiscountVerificationInfo')({
    discountType,
    requestId,
  });
}

export function selectReverifyNow() {
  return {
    type: PaymentsConstants.Actions.REVERIFY_LINK_CLICKED,
  };
}
